import QueueEdit from './QueueEdit';
export default QueueEdit;